export const Fonts = {
  RED_HAT_FONT: "Red Hat Display",
  OPEN_SANS_FONT: "Open Sans",
};
